/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useEffect, useRef, useState } from "react";
import Navbar from "../core/components/NavBar";
import UserContext from "../core/UserContext";
import { Link } from "react-router-dom";
import { useAccounts } from "../core/lib/mockAccounts";
import { FaEye } from "react-icons/fa";
import apiRoutes from "../api/apiRoutes";
import UsePagination from "../core/components/usePagination";
import { ExportPDF } from "./exportPDF";

const PolicyholderAccount = () => {
  const { userData, setUserData } = useContext(UserContext);
  console.log("ud:", userData);
  const ref = useRef();
  const policyModalRef = useRef(null);
  const riskModalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [policyModal, setPolicyModal] = useState({
    id: null,
    open: false,
  });

  const [riskModal, setRiskModal] = useState({
    id: null,
    open: false,
  });

  const handlePolicyModal = (id, state) => {
    setPolicyModal({
      id: state === "open" ? id : null,
      open: state === "open",
    });
  };

  const handleRiskModal = (id, state) => {
    setRiskModal({
      id: state === "open" ? id : null,
      open: state === "open",
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        policyModalRef.current &&
        !policyModalRef.current.contains(event.target)
      ) {
        handlePolicyModal(null, "close");
      }
      if (
        riskModalRef.current &&
        !riskModalRef.current.contains(event.target)
      ) {
        handleRiskModal(null, "close");
      }
    };

    if (policyModal.open || riskModal.open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [policyModal.open, riskModal.open]);

  const {
    currentItems,
    itemsPerPage,
    totalPages,
    currentPage,
    totalItems,
    onLimitChange,
    onPageChange,
    nullData,
  } = useAccounts({
    endpoint: apiRoutes.allAccounts,
    worker: userData.data.id,
  });

  return (
    <>
      <Navbar
        name={
          userData
            ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
            : ""
        }
      />
      <div className="tw-font-haas container tw-px-3 sm:tw-px-5 tw-w-full tw-max-w-7xl tw-mx-auto">
        <section className="tw-pt-8">
          <div className="tw-flex tw-items-start tw-justify-between tw-gap-x-4">
            <div className="tw-max-w-[60%] mb-3">
              <h5 className="tw-font-semibold">Manage Policyholder Accounts</h5>
              <p>
                Easily access and manage all policyholder accounts in one place.
                Select a customer to view details, track contributions, and
                manage payments efficiently.
              </p>
            </div>

            <Link
              to={`${process.env.REACT_APP_BASENAME}/create-quotation`}
              className="tw-no-underline tw-flex tw-items-center tw-justify-center tw-rounded-md tw-font-semibold ila-bg text-white tw-w-[200px] tw-h-[50px]"
            >
              {" "}
              Create New Quotation
            </Link>
          </div>
        </section>

        {loading && (
          <>
            <div
              style={{ marginTop: 150 }}
              className="d-flex flex-column justify-content-center align-items-center"
            >
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading....</span>
              </div>
              <div>Please wait...</div>
            </div>
          </>
        )}

        <div className="tw-border tw-border-black/10 tw-bg-transparent tw-rounded-md tw-w-full tw-overflow-x-auto">
          <div className="tw-py-2 tw-px-4 tw-flex tw-flex-end tw-items-center tw-justify-end tw-gap-x-2">
            <UsePagination
              mainpagination={"tw-hidden"}
              showtotal={"tw-hidden"}
              limit={itemsPerPage}
              total={totalItems}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
              onLimitChange={onLimitChange}
            />
            <ExportPDF tRef={ref} fileName={"Accounts"} />
          </div>

          {nullData ? (
            nullData
          ) : (
            <table
              ref={ref}
              style={{ padding: "0px !important" }}
              className="table tw-table-auto tw-whitespace-nowrap"
            >
              <thead className="tw-w-full tw-h-[40px]">
                <tr
                  style={{ color: "#BEC663" }}
                  className="tw-border-t tw-border-b tw-border-black/10 tw-w-full tw-h-full tw-bg-[#F1F4D0] [&>th]:!tw-text-[#BEC663]"
                >
                  <th scope="col">Policyholder</th>
                  <th scope="col">Policy Number</th>
                  <th scope="col">Risk Sum Assured</th>
                  <th scope="col">Fund Value (MUR)</th>
                  <th scope="col">Premium (Frequency)</th>
                  <th scope="col">Next Due Date</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>

              <tbody className="tw-h-[60px] tw-text-sm tw-capitalize">
                {currentItems.map((application, index) => {
                  const quotation =
                    application.quotations?.[0] ||
                    application?.jointQuotations?.[0];
                  const isPolicyOpen =
                    policyModal.open &&
                    policyModal.id === quotation?.temporaryId;
                  const isRiskOpen =
                    riskModal.open && riskModal.id === quotation?.temporaryId;

                  const riskData = {
                    death: quotation?.initialSumAssured,
                    disability: quotation?.initialSumAssured,
                  };

                  return (
                    <tr className="" key={index}>
                      <td scope="row">
                        {application.name ? application.name : "Not Available"}
                      </td>

                      {/* Policy Number Column */}
                      <td className="tw-relative tw-flex tw-items-center tw-gap-x-2">
                        {quotation?.temporaryId ? quotation.temporaryId : "N/A"}{" "}
                        <FaEye
                          onClick={() =>
                            handlePolicyModal(
                              quotation?.temporaryId,
                              isPolicyOpen ? "close" : "open"
                            )
                          }
                          className="!tw-text-[#BEC663] tw-size-5 tw-cursor-pointer"
                        />
                        {isPolicyOpen && (
                          <div
                            ref={policyModalRef}
                            className="tw-absolute tw-right-0 tw-top-full tw-z-10 tw-bg-white tw-w-fit tw-max-h-[300px] tw-overflow-y-auto tw-border tw-border-black/20 tw-rounded-lg tw-p-4 tw-shadow-lg"
                          >
                            <div className="tw-space-y-2">
                              {application?.quotations?.map((quote, idx) => (
                                <div key={`quote-${idx}`}>
                                  {quote.temporaryId || "N/A"}
                                </div>
                              ))}
                              {application?.jointQuotations?.map(
                                (jointQuote, idx) => (
                                  <div key={`joint-${idx}`}>
                                    {jointQuote.temporaryId || "N/A"}
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}
                      </td>

                      {/* Risk Sum Assured Column */}
                      <td className="tw-relative">
                        <div className="tw-flex tw-items-center tw-gap-x-2">
                          {quotation?.initialSumAssured
                            ? parseFloat(
                                quotation.initialSumAssured
                              ).toLocaleString()
                            : 0}
                          <FaEye
                            onClick={() =>
                              handleRiskModal(
                                quotation?.temporaryId,
                                isRiskOpen ? "close" : "open"
                              )
                            }
                            className="!tw-text-[#BEC663] tw-size-5 tw-cursor-pointer"
                          />
                          {isRiskOpen && (
                            <div
                              ref={riskModalRef}
                              className="tw-absolute tw-left-0 tw-top-full tw-z-10 tw-bg-white tw-w-fit tw-max-h-[300px] tw-overflow-y-auto tw-border tw-border-black/20 tw-rounded-lg tw-p-4 tw-shadow-lg"
                            >
                              <div className="tw-flex tw-items-start tw-gap-3">
                                <span className="tw-flex tw-flex-col">
                                  <span className="tw-text-black/50">
                                    Death
                                  </span>
                                  <b>
                                    {riskData.death
                                      ? parseFloat(
                                          riskData.death
                                        )?.toLocaleString()
                                      : "N/A"}{" "}
                                    MUR
                                  </b>
                                </span>
                                <span className="tw-flex tw-flex-col">
                                  <span className="tw-text-black/50">
                                    {" "}
                                    Disability
                                  </span>

                                  <b>
                                    {riskData.disability
                                      ? parseFloat(
                                          riskData.disability
                                        )?.toLocaleString()
                                      : "N/A"}{" "}
                                    MUR
                                  </b>
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>

                      <td>{quotation?.fundValue ? quotation.fundValue : 0}</td>
                      <td>
                        {quotation?.paymentInsurancePlan
                          ? quotation.paymentInsurancePlan
                          : "N/A"}
                      </td>
                      <td>
                        {quotation?.nextDueDate
                          ? new Date(quotation.nextDueDate).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              }
                            )
                          : "Not available"}
                      </td>
                      <td>
                        <a
                          className="!tw-text-[#BEC663] !tw-no-underline"
                          href={`accounts/${
                            quotation?.userId || quotation?.userJointId
                          }`}
                        >
                          View More
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          <UsePagination
            pgdrop="tw-hidden"
            limit={itemsPerPage}
            total={totalItems}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            onLimitChange={onLimitChange}
          />
        </div>
      </div>
    </>
  );
};

export default PolicyholderAccount;
